// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__-lSjV","tab":"ProcedureTabs_tab__UPftF"};